import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpidernetIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 42,
	height: 52,
	viewBox: "0 0 42 52",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.65041 8.09779L3.69196 9.51735M20.0244 20.8738L32.0105 29.0757M20.0244 20.8738L17.2021 8.09779M20.0244 20.8738L33.3577 16.9636M20.0244 20.8738L9.45528 13.5248M20.0244 20.8738L13.5 26.5M20.0244 20.8738L21.886 32M1 37.9085L3.03252 36.0886M15.6341 1L16.4181 4.5489M41 35.2271L39 33.8586M41 14.7224L35.1463 16.4391M25.065 51L24.1282 45.4006M5.06504 34.2686C7.88091 33.4314 15.4484 33.3659 23.1913 39.8013M5.06504 34.2686L9.98374 29.8644M5.06504 34.2686L3.03252 36.0886M23.1913 39.8013L22.5315 35.858M23.1913 39.8013L24.1282 45.4006M22.5315 35.858C23.6161 33.2818 27.0302 28.3186 32.0105 29.0757M22.5315 35.858L21.886 32M32.0105 29.0757L34.3155 30.653M35.1463 16.4391C34.3756 19.2843 33.1304 26.1104 34.3155 30.653M35.1463 16.4391L33.3577 16.9636M34.3155 30.653L39 33.8586M17.2021 8.09779C20.0399 10.6435 27.2439 15.9806 33.3577 16.9636M17.2021 8.09779L16.4181 4.5489M16.4181 4.5489C14.9965 6.25762 11.0054 10.0221 6.41403 11.4101M6.41403 11.4101L9.45528 13.5248M6.41403 11.4101L3.69196 9.51735M9.45528 13.5248C10.458 16.4476 11.9675 23.8076 9.98374 29.8644M9.98374 29.8644L13.5 26.5M3.69196 9.51735C5.66727 14.8235 8.30081 27.5664 3.03252 36.0886M13.5 26.5C15.2573 26.3932 20.1948 26.8 21.886 32M39 33.8586C35.4106 34.5061 27.4112 37.7211 24.1282 45.4006",
		stroke: "#5590FF",
		strokeWidth: 2
	})]
});
const ForwardRef = forwardRef(SvgSpidernetIcon);
export default ForwardRef;
